import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { toast } from '../ui/sonner';
import { messageErreur } from '../../lib/erreurs';

// File downloads are auth-protected, so a plain <img src> would 401.
// This component fetches via the axios instance (which injects the bearer
// token) and exposes the bytes as a blob URL for preview.
export function AuthBlob({ url, fallback, render, className, errorFallback }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    if (!url) return undefined;
    setBlobUrl(null);
    setErrored(false);
    let revoked = false;
    let createdUrl = null;
    api
      .get(url.replace('/api/v1', ''), { responseType: 'blob' })
      .then((resp) => {
        if (revoked) return;
        createdUrl = URL.createObjectURL(resp.data);
        setBlobUrl(createdUrl);
      })
      .catch(() => {
        if (!revoked) setErrored(true);
      });
    return () => {
      revoked = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url]);

  if (errored) {
    if (errorFallback !== undefined) return errorFallback;
    return <p role="alert" className="p-6 text-sm text-destructive">Impossible de charger l’aperçu. Réessayez ou téléchargez le document.</p>;
  }
  if (!blobUrl) return fallback || null;
  return render ? render(blobUrl) : (
    <img src={blobUrl} alt="" className={className} loading="lazy" />
  );
}

// Le téléchargement emprunte le même chemin authentifié que l'aperçu: un
// `<a download href="/api/...">` part sans le jeton porteur et ne ramène
// qu'une page d'erreur 401 enregistrée sous le nom du document.
export const downloadAuthFile = async (url, fileName) => {
  if (!url) return;
  try {
    const resp = await api.get(url.replace('/api/v1', ''), { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(resp.data);
    const lien = document.createElement('a');
    lien.href = blobUrl;
    lien.download = fileName || 'document';
    document.body.appendChild(lien);
    lien.click();
    lien.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
  } catch (err) {
    console.error('Failed to download document', err);
    toast.error(messageErreur(err, 'Impossible de télécharger le document'));
  }
};
